export enum MasterDataErrorType {
    Unknown = 'Unknown'
}

export class MasterDataError extends Error {
    name = 'MasterDataError';
    type: MasterDataErrorType;

    constructor(type: MasterDataErrorType = MasterDataErrorType.Unknown, message?: string) {
        super(message ?? MasterDataErrorMessages[type]);

        this.type = type;
    }
}

export const MasterDataErrorMessages: Record<MasterDataErrorType, string> = {
    [MasterDataErrorType.Unknown]: 'Oops, something went wrong.'
};
